export const API_ASK_AI_KB_URL = process.env.REACT_APP_API_KNOWLEDGEBASE_URL ?? '';
